import React from 'react'
import { motion } from 'framer-motion'
// import { FaLinkedin } from 'react-icons/fa'

const employeeProfile = [
  {
    name: "Matthew Grayson",
    position: "Chief Executive Officer (CEO)",
    photo: "/ceo.jpeg",
    // profileLink: "https://linkedin.com",
    // icon: <FaLinkedin className='text-2xl mr-2' />,
    description: "A British civil engineer and visionary entrepreneur, Jonathan brings over 22 years of global experience in construction and infrastructure development. Before founding Arqelio, he led major urban regeneration projects across Europe and West Africa. Under his leadership, the company has become known for merging traditional craftsmanship with cutting-edge technology to deliver future-ready solutions."
  },
  {
    name: " Melissa Grant",
    position: "Chief Operating Officer (COO)",
    photo: "/coo.jpeg",
    // profileLink: "https://linkedin.com",
    // icon: <FaLinkedin />,
    description: "An operations powerhouse from the U.S., Melissa has spent the last 15 years optimizing large-scale engineering and logistics workflows. With a background in construction project management and lean operations, she ensures every Arqelio project meets its timeline, budget, and quality benchmarks. Her strategic coordination fuels seamless project execution from blueprint to handover."
  },
  {
    name: "Richard “Rick” Carter",
    position: "Director of Engineering & Infrastructure",
    photo: "/director2.jpeg",
    // profileLink: "https://linkedin.com",
    // icon: <FaLinkedin />,
    description: "Rick is an American structural engineer with a passion for sustainable development and infrastructure innovation. He has led engineering teams on government-backed road networks, bridges, and urban drainage systems. At Arqelio, Rick is responsible for the technical precision and structural integrity of all civil works — ensuring every build meets global standards."
  },
  {
    name: "Victoria Lewis",
    position: "Head of Consulting & Strategic Projects",
    photo: "/consult-head.jpeg",
    // profileLink: "https://linkedin.com",
    // icon: <FaLinkedin />,
    description: "Educated in the UK and trained in business strategy, Victoria brings a unique combination of engineering awareness and executive insight. She leads the consulting arm of Arqelio, helping clients translate vision into executable project frameworks. Her specialties include risk assessment, project financing, and stakeholder alignment — all critical for success in today’s fast-paced build environment."
  },
  {
    name: "Thomas Walker",
    position: "Director of Logistics & Supply Chain",
    photo: "/logistics-head.jpeg",
    // profileLink: "https://linkedin.com",
    // icon: <FaLinkedin />,
    description: "A seasoned logistics expert from Manchester, Thomas has managed transport and supply operations across Europe, Asia, and Africa. At Arqelio, he oversees the end-to-end logistics ecosystem — from sourcing and warehousing to last-mile delivery. His sharp eye for efficiency ensures projects never suffer delays from the supply chain side."
  },
]


const Employees = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
      className="cursor-pointer max-w-7xl mx-auto py-20 px-6 bg-white text-center rounded-xl shadow-md"
    >
      <h2 className="text-4xl font-bold text-[#29313f] mb-8 tracking-wide">
        The Minds Behind the Build
      </h2>

      {/* Executives profile */}
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8'>
        {employeeProfile.map((executive, index) => {
          return (
            <motion.div
              key={index}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 1 }}
              className="bg-gray-100 p-6 rounded-xl shadow-lg text-left hover:scale-105 transition-all"
            >
              <img
                src={executive.photo}
                alt={executive.name}
                className="rounded-lg object-cover w-full h-64 shadow-md hover:opacity-80 transition-opacity"
              />

              <h3 className="mt-4 text-xl font-bold text-gray-900">
                {executive.name}
              </h3>

              <p className="mt-2 font-semibold text-gray-700">
                {executive.position}
              </p>

              <p className="mt-2 text-gray-600 text-sm">
                {executive.description}
              </p>

              {/* <a
                target="_blank"
                rel="noopener noreferrer"
                className='inline-flex items-center mt-3 text-[#0077b5] hover:text-[#005582] transition'
                href={executive.profileLink}
              >
                {executive.icon}
                <span className="font-medium">Connect on LinkedIn</span>
              </a> */}
            </motion.div>
          )
        })}
      </div>
    </motion.section>
  )
}

export default Employees